import WhatsAppEnquiryForm from "@/components/feature/WhatsAppEnquiryForm";

export default function Contact() {
  return (
    <section id="contact" className="bg-[#EAF5E1] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white px-3 py-1.5 rounded-full mb-3 border border-[#7FBF3F]/20">
            Contact Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Get in Touch on WhatsApp
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Fill in your details and we'll send them directly to our WhatsApp. Fast, easy, and personal.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Left: Contact Info */}
          <div className="w-full lg:w-2/5 flex flex-col gap-5">
            <div className="bg-white rounded-2xl p-6 border border-[#7FBF3F]/15">
              <h3 className="font-semibold text-[#1B2A4A] text-base mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>Contact Information</h3>
              <div className="flex flex-col gap-4">
                {[
                  { icon: "ri-phone-line", label: "Phone", value: "+91 99451 24133", href: "tel:+919945124133" },
                  { icon: "ri-phone-line", label: "Landline", value: "080 27822444", href: "tel:08027822444" },
                  { icon: "ri-mail-line", label: "Email", value: "sales@urbaninfraproject.in", href: "mailto:sales@urbaninfraproject.in" },
                  { icon: "ri-time-line", label: "Working Hours", value: "11:00 AM – 7:00 PM", href: null },
                ].map((item) => (
                  item.href ? (
                    <a key={item.label} href={item.href} className="flex items-start gap-3 group cursor-pointer">
                      <div className="w-9 h-9 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0 group-hover:bg-[#1B2A4A] transition-colors">
                        <i className={`${item.icon} text-[#7FBF3F] group-hover:text-white transition-colors`}></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-400 mb-0.5">{item.label}</div>
                        <div className="text-sm font-medium text-gray-700">{item.value}</div>
                      </div>
                    </a>
                  ) : (
                    <div key={item.label} className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                        <i className={`${item.icon} text-[#7FBF3F]`}></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-400 mb-0.5">{item.label}</div>
                        <div className="text-sm font-medium text-gray-700">{item.value}</div>
                      </div>
                    </div>
                  )
                ))}
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-[#F36F21]"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-400 mb-0.5">Address</div>
                    <div className="text-sm font-medium text-gray-700">#2, CNR Complex, First Floor, Muthanallur Cross, Sarjapur Main Road, Bangalore – 562125</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden h-52 border border-[#7FBF3F]/15">
              <iframe
                title="Urban Infra Office Location"
                src="https://maps.google.com/maps?q=VPPQ%2BH8+Bengaluru,+Karnataka&t=&z=17&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <a
              href="https://maps.app.goo.gl/Nw8RvpZjMwLjBbhh8?g_st=ic"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold text-sm px-5 py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-navigation-fill"></i>
              Get Directions
            </a>
          </div>

          {/* Right: WhatsApp Form */}
          <div className="w-full lg:w-3/5">
            <WhatsAppEnquiryForm />
          </div>
        </div>
      </div>
    </section>
  );
}
